import { GoogleAnalytics } from '../../../services'

export const anonymous = () => {
  // google analytics
  GoogleAnalytics.identify()
}
